/**
 * @generated SignedSource<<301cffb1f5fe010ce4a5283f2420bfa0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportSurveysTable_PaginationFragment$data = {
  readonly content: {
    readonly webForm: {
      readonly currentRevision: {
        readonly questions: {
          readonly edges: ReadonlyArray<{
            readonly cursor: string;
            readonly node: {
              readonly id: string;
              readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportSurveysTableRowFragment">;
            };
          }>;
          readonly pageInfo: {
            readonly endCursor: string | null;
            readonly hasNextPage: boolean;
            readonly hasPreviousPage: boolean;
            readonly startCursor: string | null;
          };
          readonly totalCount: number;
        };
      };
    } | null;
  };
  readonly id: string;
  readonly " $fragmentType": "AdminMembersReportSurveysTable_PaginationFragment";
};
export type AdminMembersReportSurveysTable_PaginationFragment$key = {
  readonly " $data"?: AdminMembersReportSurveysTable_PaginationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportSurveysTable_PaginationFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "content",
  "webForm",
  "currentRevision",
  "questions"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "before"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentUsageId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "last"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "memberOrganizationMembershipId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "bidirectional",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": {
          "count": "last",
          "cursor": "before"
        },
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./AdminMembersReportSurveysTablePaginationQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "AdminMembersReportSurveysTable_PaginationFragment",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WebForm",
          "kind": "LinkedField",
          "name": "webForm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WebFormRevision",
              "kind": "LinkedField",
              "name": "currentRevision",
              "plural": false,
              "selections": [
                {
                  "alias": "questions",
                  "args": null,
                  "concreteType": "WebFormQuestionNodeConnection",
                  "kind": "LinkedField",
                  "name": "__AdminMembersReportSurveysTable_questions_connection",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalCount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WebFormQuestionNodeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "cursor",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WebFormQuestion",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            {
                              "args": [
                                {
                                  "kind": "Variable",
                                  "name": "contentUsageId",
                                  "variableName": "contentUsageId"
                                },
                                {
                                  "kind": "Variable",
                                  "name": "organizationMembershipId",
                                  "variableName": "memberOrganizationMembershipId"
                                }
                              ],
                              "kind": "FragmentSpread",
                              "name": "AdminMembersReportSurveysTableRowFragment"
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "__typename",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PageInfoObjectType",
                      "kind": "LinkedField",
                      "name": "pageInfo",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "endCursor",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "startCursor",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hasNextPage",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hasPreviousPage",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};
})();

(node as any).hash = "cac47f46ea702d98f9f5299cff205c2a";

export default node;
